import * as _ from 'underscore';
import { schema } from 'normalizr';

import workoutSetSchema from '../workoutSet/schema';
import savedWorkoutSetSchema from '../savedWorkoutSet/schema';

const workoutSchema = new schema.Entity(
    'sessions',
    {
        sets: new schema.Array(workoutSetSchema),
        addedSets: new schema.Array(savedWorkoutSetSchema)
    },
    {
        idAttribute: entity => entity.workout_id,
        processStrategy: entity => {
            const item = { ...entity };
            const items = _.sortBy({ ...entity.sets }, 'order');
            item.sets = items;
            return item;
        }
    }
);

export const workoutSummarySchema = new schema.Entity(
    'summarySessions',
    {
        sets: new schema.Array(workoutSetSchema),
        addedSets: new schema.Array(savedWorkoutSetSchema)
    },
    {
        idAttribute: entity => entity.workout_id,
        processStrategy: entity => {
            const item = { ...entity };
            const sets = _.filter(item.sets, set => set.id);
            const addedSets = _.filter(item.sets, set => set.id === null);
            item.sets = sets;
            item.addedSets = addedSets;
            return item;
        }
    }
);

export default workoutSchema;
